import { render, staticRenderFns } from "./CreateAtlasPlatform.vue?vue&type=template&id=214b6304"
import script from "./CreateAtlasPlatform.vue?vue&type=script&lang=ts"
export * from "./CreateAtlasPlatform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports